jQuery(document).ready(function ($) {
  if ($('body').hasClass('page-template-ocrolus-2024')) {
    const chart2024Q4FutureGrowth = document.getElementById('2024-q4-futuregrowth');

    new Chart(chart2024Q4FutureGrowth, {
      type: 'bar',
      data: {
        labels: ['Q4 2023', 'Q1 2024', 'Q2 2024', 'Q3 2024', 'Q4 2024'],
        datasets: [{
          label: 'Significant Growth',
          data: ['25.8', '30.8', '29.83', '27.2', '29.5'],
          backgroundColor: '#0064dd',
          borderColor: '#0064dd',
        },
        {
          label: 'Moderate Growth',
          data: ['65.8', '61.8', '62.2', '65.0', '64.5'],
          backgroundColor: '#000082',
          borderColor: '#000082',
        },
        {
          label: 'No Growth',
          data: ['8.4', '7.3', '8.5', '7.8', '5.9'],
          backgroundColor: '#83dcc1',
          borderColor: '#83dcc1',
        }]
      },
      options: {
        plugins: {
          tooltip: {
            callbacks: {
              label: function (context) {
                let label = context.dataset.label || '';

                if (label) {
                  label += ': ';
                }
                if (context.parsed.y !== null) {
                  label += context.parsed.y + '%';
                }
                return label;
              }
            }
          },
        },
        scales: {
          x: {
            grid: { display: false },
          },
          y: {
            border: { display: false },
            ticks: {
              stepSize: 10,
              callback: function (value, index, ticks) {
                return Chart.Ticks.formatters.numeric.apply(this, [value, index, ticks]) + '%';
              }
            },
            max: 70,
          }
        }
      }
    });

    const chart2024Q4Median = document.getElementById('2024-q4-median');

    let barLength = function () {
      if (window.innerWidth > 992) {
        return 50;
      } else if (window.innerWidth < 992 && window.innerWidth > 768) {
        return 30;
      } else if (window.innerWidth < 768 && window.innerWidth > 450) {
        return 15;
      } else {
        return 10;
      }
    }

    new Chart(chart2024Q4Median, {
      type: 'line',
      data: {
        labels: ['Q4 2023', 'Q1 2024', 'Q2 2024', 'Q3 2024', 'Q4 2024'],
        datasets: [
          {
            label: 'Employer Firms',
            data: ['91362', '92694', '86185', '86225', '85168'],
            borderColor: '#0064dd',
            pointBackgroundColor: 'rgba(255, 255, 255, 0)',
            pointBorderColor: '#0064dd',
            pointStyle: 'line',
            radius: barLength,
            pointHoverRadius: barLength,
            pointBorderWidth: 10,
            pointHoverBorderWidth: 10,
            stepped: 'middle',
            fill: false,
            showLine: false,
          },
          {
            label: 'Non-Employer Firms',
            data: ['46105', '47708', '42488', '42662', '41163',],
            borderColor: '#000082',
            pointBackgroundColor: 'rgba(255, 255, 255, 0)',
            pointBorderColor: '#000082',
            pointStyle: 'line',
            radius: barLength,
            pointHoverRadius: barLength,
            pointBorderWidth: 10,
            pointHoverBorderWidth: 10,
            stepped: 'middle',
            fill: false,
            showLine: false,
          },
          {
            label: 'All Applications',
            data: ['63022', '65052', '58411', '57918', '56403'],
            borderColor: '#83dcc1',
            pointBackgroundColor: 'rgba(255, 255, 255, 0)',
            pointBorderColor: '#83dcc1',
            pointStyle: 'line',
            radius: barLength,
            pointHoverRadius: barLength,
            pointBorderWidth: 10,
            pointHoverBorderWidth: 10,
            stepped: 'middle',
            fill: false,
            showLine: false,
          }
        ]
      },
      options: {
        responsive: true,
        plugins: {
          legend: { display: true },
          tooltip: {
            callbacks: {
              label: function (context) {
                let label = context.dataset.label || '';

                if (label) {
                  label += ': ';
                }
                if (context.parsed.y !== null) {
                  label += new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' }).format(context.parsed.y);
                }
                return label;
              }
            }
          },
        },
        scales: {
          x: {
            offset: true,
            title: {
              display: true,
              text: 'Quarter / Year',
            },
            grid: { display: false },
          },
          y: {
            title: {
              display: true,
              text: 'Median Monthly Revenue',
            },
            border: { display: false },
            ticks: {
              stepSize: 20000,
              callback: function (value, index, ticks) {
                return '$' + Chart.Ticks.formatters.numeric.apply(this, [value, index, ticks]);
              }
            },
            min: 40000,
            max: 100000,
          }
        }
      }
    });
  }
});
